/* ============================================================
   BE PARFUM — HALLOWEEN TAKEOVER 2026 (tijdelijke effectenlaag)
   ------------------------------------------------------------
   Alleen geladen als de Halloween-setting aan staat.
   Alle effecten: transform/opacity, geen layout shifts, geen
   pointer-events, geen geluid. Respecteert prefers-reduced-motion.
   Config komt uit window.hwConfig (gezet in snippets/halloween.liquid).
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.hwConfig || {};
  var layer = document.getElementById('hw-layer');
  if (!layer) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 767px)').matches;
  var isCheckout = /checkout/.test(location.pathname);
  var hidden = false;

  if (reduced || isCheckout) {
    // Webs blijven statisch zichtbaar (CSS), rest uit.
    revealWebs(true);
    return;
  }
  if (isMobile && cfg.mobileEffects === false) {
    revealWebs(false);
    return;
  }

  document.addEventListener('visibilitychange', function () {
    hidden = document.hidden;
  });

  var rand = function (min, max) { return Math.random() * (max - min) + min; };
  var use = function (id, cls) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    var u = document.createElementNS(ns, 'use');
    u.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + id);
    u.setAttribute('href', '#' + id);
    svg.appendChild(u);
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    if (cls) svg.setAttribute('class', cls);
    return svg;
  };
  var cleanup = function (el, ms) {
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); }, ms);
  };

  /* ---------- 1. Vallende pompoenen (entrance, 1x per sessie, alleen homepage) ---------- */
  function fallingPumpkins() {
    if (cfg.pumpkins === false || !cfg.isHome) return;
    var key = 'hw_pumpkins_seen';
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (e) {}
    var count = isMobile ? 7 : 14;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var p = document.createElement('div');
      p.className = 'hw-pumpkin';
      var size = isMobile ? rand(22, 36) : rand(26, 52);
      p.style.setProperty('--hw-size', size.toFixed(0) + 'px');
      p.style.setProperty('--hw-x', rand(2, 96).toFixed(1) + '%');
      p.style.setProperty('--hw-dur', rand(3.6, 6.2).toFixed(2) + 's');
      p.style.setProperty('--hw-delay', rand(0.1, 1.6).toFixed(2) + 's');
      p.style.setProperty('--hw-rot', (rand(-1, 1) > 0 ? 1 : -1) * rand(180, 420).toFixed(0) + 'deg');
      p.style.setProperty('--hw-drift', rand(-60, 60).toFixed(0) + 'px');
      p.appendChild(use('hw-pumpkin'));
      frag.appendChild(p);
    }
    layer.appendChild(frag);
    cleanup(null, 0);
    setTimeout(function () {
      var nodes = layer.querySelectorAll('.hw-pumpkin');
      for (var j = 0; j < nodes.length; j++) nodes[j].parentNode.removeChild(nodes[j]);
    }, 9000);
  }

  /* ---------- 2. Spin drop (af en toe, bovenrand) ---------- */
  function spiderDrop() {
    if (cfg.spiders === false || hidden) return schedule(spiderDrop, 30, 55);
    var s = document.createElement('div');
    s.className = 'hw-spider';
    s.style.setProperty('--hw-x', rand(55, 92).toFixed(1) + '%');
    s.style.setProperty('--hw-drop', (isMobile ? rand(70, 110) : rand(110, 190)).toFixed(0) + 'px');
    var thread = document.createElement('span');
    thread.className = 'hw-thread';
    var body = use('hw-spider', 'hw-spider-body');
    s.appendChild(thread);
    s.appendChild(body);
    layer.appendChild(s);
    requestAnimationFrame(function () { s.classList.add('is-dropping'); });
    cleanup(s, 5600);
    schedule(spiderDrop, isMobile ? 60 : 32, isMobile ? 110 : 70);
  }

  /* ---------- 3. Spin crawl (incidenteel, onderrand — desktop) ---------- */
  function spiderCrawl() {
    if (cfg.spiders === false || isMobile || hidden) return schedule(spiderCrawl, 70, 120);
    var c = document.createElement('div');
    c.className = 'hw-crawler';
    c.style.setProperty('--hw-bottom', rand(40, 120).toFixed(0) + 'px');
    c.appendChild(use('hw-spider'));
    layer.appendChild(c);
    requestAnimationFrame(function () { c.classList.add('is-crawling'); });
    cleanup(c, 9500);
    schedule(spiderCrawl, 75, 140);
  }

  /* ---------- 4. Skelethoofd om de hoek (zeldzaam) ---------- */
  var skullSide = Math.random() > 0.5 ? 'right' : 'left';
  function skullPeek() {
    if (cfg.skull === false || hidden) return schedule(skullPeek, 60, 100);
    if (isMobile && cfg.skullMobile === false) return;
    var k = document.createElement('div');
    k.className = 'hw-skull from-' + skullSide;
    k.appendChild(use('hw-skull'));
    layer.appendChild(k);
    requestAnimationFrame(function () { k.classList.add('is-peeking'); });
    cleanup(k, 4000);
    skullSide = skullSide === 'right' ? 'left' : 'right';
    schedule(skullPeek, isMobile ? 120 : 65, isMobile ? 200 : 115);
  }

  /* ---------- 5. Spook door de achtergrond (zeer subtiel, desktop) ---------- */
  function ghostDrift() {
    if (isMobile || hidden) return schedule(ghostDrift, 60, 100);
    var g = document.createElement('div');
    g.className = 'hw-ghost';
    g.appendChild(use('hw-ghost'));
    layer.appendChild(g);
    requestAnimationFrame(function () { g.classList.add('is-drifting'); });
    cleanup(g, 14500);
    schedule(ghostDrift, 55, 95);
  }

  /* ---------- 6. Easter egg: vleermuis vliegt weg bij hover op logo ---------- */
  function batOnLogo() {
    var logo = document.querySelector('.header .logo-image');
    if (!logo || isMobile) return;
    var last = 0;
    logo.addEventListener('mouseenter', function () {
      var now = Date.now();
      if (now - last < 12000) return;
      last = now;
      var r = logo.getBoundingClientRect();
      var b = document.createElement('div');
      b.className = 'hw-bat-fly';
      b.style.setProperty('--hw-x', (r.right - 10) + 'px');
      b.style.setProperty('--hw-y', (r.top + r.height / 2 - 10) + 'px');
      b.appendChild(use('hw-bat'));
      layer.appendChild(b);
      cleanup(b, 2000);
    });
  }

  /* ---------- 7. Webs in secties: verschijnen zodra ze in beeld komen ---------- */
  function revealWebs(instant) {
    var webs = document.querySelectorAll('.hw-web');
    if (!webs.length) return;
    if (instant || !('IntersectionObserver' in window)) {
      for (var i = 0; i < webs.length; i++) webs[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    for (var j = 0; j < webs.length; j++) io.observe(webs[j]);
  }

  /* ---------- Planner ---------- */
  function schedule(fn, minSec, maxSec) {
    setTimeout(fn, rand(minSec, maxSec) * 1000);
  }

  function init() {
    revealWebs(false);
    batOnLogo();
    setTimeout(fallingPumpkins, 450);
    schedule(spiderDrop, 14, 28);
    schedule(spiderCrawl, 40, 70);
    schedule(skullPeek, 35, 60);
    // Secties die later (ajax) geladen worden: webs alsnog activeren
    document.addEventListener('shopify:section:load', function () { revealWebs(false); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
